module.exports = __webpack_public_path__ + "static/media/header-banner-image.614e3270.png";